import { Component, Input, OnInit } from '@angular/core';

interface PermissionOption {
    id: number;
    name: string;
}

@Component({
    selector: 'user-group-name-info',
    templateUrl: './userGroupNameInfo.component.html',
    standalone: false
})
export class UserGroupNameInfoComponent implements OnInit {
    @Input() userGroup;
    @Input() canEdit: boolean;

    permissionOptions: PermissionOption[];
    selectedDefaultPermissions: PermissionOption;


    ngOnInit(): void {
        this.permissionOptions = [
            { id: 0, name: 'None' },
            { id: 1, name: 'View' },
            { id: 2, name: 'Edit' }
        ];

        this.selectedDefaultPermissions = this.permissionOptions.filter(p => p.id === (this.userGroup.grantWriteToNewCompanies ? 2 : this.userGroup.grantReadToNewCompanies ? 1 : 0))[0];
    }

    permissionChanged(): void {
        this.userGroup.grantReadToNewCompanies = this.selectedDefaultPermissions.id > 0;
        this.userGroup.grantWriteToNewCompanies = this.selectedDefaultPermissions.id > 1;
    }
}
